import { render, staticRenderFns } from "./MovementValues.vue?vue&type=template&id=2a07ef94&scoped=true&"
import script from "./MovementValues.vue?vue&type=script&lang=js&"
export * from "./MovementValues.vue?vue&type=script&lang=js&"
import style0 from "./MovementValues.vue?vue&type=style&index=0&id=2a07ef94&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a07ef94",
  null
  
)

export default component.exports